import { forwardRef } from 'react';
import Slide, { type SlideProps } from '@mui/material/Slide';

const SlideTransition = forwardRef<any, SlideProps>(
  ({ direction = 'down', ...props }, ref) => {
    return <Slide ref={ref} direction={direction} {...props} />;
  }
);

export default SlideTransition;
